<p-floatlabel variant="on">
  <p-inputnumber
    [formControl]="control()"
    [invalid]="control().invalid && control().touched"
    [min]="min()"
    [max]="max()"
    [minFractionDigits]="minFractionDigits()"
    [maxFractionDigits]="maxFractionDigits()"
    [mode]="mode()"
    [currency]="currency()"
    [prefix]="prefix()"
    [suffix]="suffix()"
    fluid
  />
  <label>
    {{ label() }}
    @if (isRequired()) {
      <span class="text-red-500">*</span>
    }
  </label>
</p-floatlabel>
@if (control().invalid && control().touched && control().hasError('required')) {
  <p-message severity="error" size="small" variant="simple">{{ 'error.required' | translate }}</p-message>
}